import { createSelector } from '@ngrx/store';

import { getJobsSelectedId } from '@collections/jobs/jobs.selectors';
import { Candidate, CandidateAdapter } from '@shared/models';

import { CollectionsState, getCollectionsState } from '../collections.reducer';
import { hasAnonymization } from '../users';
import { candidateAggregationAdapter, CandidateAggregationsState } from './aggregations.reducer';

export const getAggregationsState = createSelector(
  getCollectionsState,
  (state: CollectionsState) => !!state && state.aggregations,
);

export const { selectEntities: getAggregationsEntities } =
  candidateAggregationAdapter.getSelectors(getAggregationsState);

export const getAggregation = createSelector(
  getAggregationsEntities,
  hasAnonymization,
  (entities, anonymization: boolean, { jobId, anonymize }) =>
    !!jobId &&
    !!entities &&
    !!entities[jobId] && {
      ...entities[jobId],
      candidates: {
        content:
          (!!entities[jobId].candidates &&
            !!entities[jobId].candidates.content &&
            entities[jobId].candidates.content.map(
              (candidate: Candidate) =>
                new CandidateAdapter(candidate, !!anonymization && anonymize),
            )) ||
          [],
      },
    },
);

export const getAggregatedJobData = createSelector(
  getAggregationsState,
  getJobsSelectedId,
  (state: CandidateAggregationsState, jobId) => state.entities[jobId],
);

export const isAggregationLoaded = createSelector(
  getAggregationsState,
  (state: CandidateAggregationsState, { jobId }) =>
    // @ts-ignore
    !!state && !!jobId && state.ids.includes(jobId),
);

export const getAggregatedJobDataForJobId = createSelector(
  getAggregationsState,
  (state, { jobId }) => state.entities?.[jobId],
);

export const getTotalDirectPerPhase = createSelector(
  getAggregationsState,
  (state: CandidateAggregationsState) => !!state && state.totalDirectCandidatesPerPhases,
);

export const getActiveJobsCount = createSelector(
  getAggregationsState,
  (state: CandidateAggregationsState) => !!state && state.pipelineActiveJobsCount,
);

export const getTotalApplicantsCount = createSelector(
  getAggregationsState,
  (state: CandidateAggregationsState) => !!state && state.pipelineAggregatedMatches?.totalDirect,
);

export const getAggregatedMatches = createSelector(
  getAggregationsState,
  (state: CandidateAggregationsState) => !!state && state.pipelineAggregatedMatches,
);
